import {Box, Heading, HStack, Image, Text, VStack} from "@chakra-ui/react";
import {ReactComponent as PercentIcon} from "../../../assets/icons/PercentIcon.svg";
import {ReactComponent as MoneyBag} from "../../../assets/icons/money-bag.svg";
import {ReactComponent as Wallet} from "../../../assets/icons/wallet_colored.svg";
import {ReactComponent as Percents} from "../../../assets/icons/Percents.svg";

export const ReferalProgram = () => {


    return (
        <Box
            w={'full'}
            border={'1px solid'}
            borderColor={'purple.500'}
            overflow={'hidden'}
            borderRadius={'64px'}
            px={'22px'}
            py={'48px'}
            color={'neutral.100'}
            position={'relative'}>
            <Image
                position={'absolute'}
                w={'full'}
                h={'full'}
                top={'0'}
                zIndex={1}
                left={'0'}
                src={'/images/referal_program_bg.png'}/>
            <Box
                zIndex={999}
                m={'auto'}
                maxW={'600px'}>
                <Heading fontSize={{base: 'heading.3xl',lg: 'display.md'}}>
                    Referral Program Comparison
                </Heading>
                <Text color={'neutral.300'} fontSize={{base: 'body.md',lg:'heading.2xl'}}>
                    Earn more, faster, with our exclusive Early Access referral program.Earn
                    more, faster, with our exclusive Early Access referral program.
                </Text>
            </Box>
            <HStack
                position={'relative'}
                alignItems={{base: 'center',md:'start'}}
                zIndex={999}
                flexDirection={{base: 'column', md: 'row'}}
                mt={'90px'}>
                <VStack
                    justifyContent={'space-between'}
                    flex={'1'}>
                    <Box>
                        <Box maxW={'318px'} textAlign={'center'}>
                            <Heading fontSize={{base: 'heading.3xl',lg: 'display.sm'}}>Early Access Users: 40% Commission</Heading>
                            <Text color={'neutral.300'} fontSize={'heading.2xl'}>Flat rate on all referrals—no tiers!</Text>
                        </Box>
                        <Box mt={'100px'}>
                            <PercentIcon />
                        </Box>
                    </Box>
                    <Box
                        position={'absolute'}
                        left={'120px'}
                        bottom={'0'}>
                        <HStack>
                            <Wallet />
                            <Text fontSize={'body.lg'}>Early Access Users: 40% Commission</Text>
                        </HStack>
                        <HStack mt={'24px'}>
                            <MoneyBag />
                            <Text fontSize={'body.lg'}>Get paid every week! Minimum withdrawal threshold: $50</Text>
                        </HStack>
                    </Box>
                </VStack>
                <VStack
                    gap={'36px'}
                    flex={'1'}>
                    <Heading fontSize={'display.sm'}>Standard Referral Program</Heading>
                    <HStack
                        gap={'37px'}
                        alignItems={'start'}>
                        <Box>
                            <Percents />
                        </Box>
                        <VStack
                            gap={'160px'}>
                            <Box>
                                <Heading fontSize={'display.md'}>Text</Heading>
                                <Text fontSize={'heading.3xl'} color={'neutral.500'}>Subtext</Text>
                            </Box>
                            <Box>
                                <Heading fontSize={'display.md'}>Text</Heading>
                                <Text fontSize={'heading.3xl'} color={'neutral.500'}>Subtext</Text>
                            </Box>
                            <Box mt={'15px'}>
                                <Heading fontSize={'display.md'}>Text</Heading>
                                <Text fontSize={'heading.3xl'} color={'neutral.500'}>Subtext</Text>
                            </Box>
                            <Box mt={'5px'}>
                                <Heading fontSize={'display.md'}>Text</Heading>
                                <Text fontSize={'heading.3xl'} color={'neutral.500'}>Subtext</Text>
                            </Box>
                            <Box mt={'5px'}>
                                <Heading fontSize={'display.md'}>Text</Heading>
                                <Text fontSize={'heading.3xl'} color={'neutral.500'}>Subtext</Text>
                            </Box>
                        </VStack>
                    </HStack>
                </VStack>
            </HStack>
        </Box>
    )
}